export const ExtraAlwaysIncluded = (extra: string, service: { Tags: string[] }) =>
  !!service?.Tags?.some((t) => [`${extra}Only`, `${extra}Included`].includes(t));
